// removed by extract-text-webpack-plugin
module.exports = {"orderConfirmation":"vPvm2","innerContainer":"_3WzHo","receiptContainer":"_2wIFz","receiptHeader":"_1fr5j","header":"_3vnv2","subheader":"_1Oq_t","message":"hqF7p","storeLogo":"_3Stf0","buttonsContainer":"O-5y_","continueShoppingButton":"_2BFWK"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/OrderConfirmation/index.sass
// module id = 1489
// module chunks = 1